import React, { useState } from 'react';
import { Pencil, Check, X } from 'lucide-react';

function ReadOnlyField({ label, value }) {
  return (
    <div>
      <dt className="text-xs font-medium text-ga-text-muted">{label}</dt>
      <dd className="mt-0.5 text-sm text-ga-text-primary">{value || '—'}</dd>
    </div>
  );
}

export default function PersonalDetailsSection({ profile, onSaveName, saving }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(profile?.name || '');
  const [error, setError] = useState('');

  const startEdit = () => {
    setName(profile?.name || '');
    setError('');
    setEditing(true);
  };

  const cancelEdit = () => {
    setEditing(false);
    setError('');
  };

  const handleSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Name is required');
      return;
    }
    try {
      await onSaveName(trimmed);
      setEditing(false);
      setError('');
    } catch (err) {
      setError(err.message || 'Failed to save name');
    }
  };

  return (
    <section className="ga-card rounded-lg border border-ga-border-subtle/60 p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm font-semibold text-ga-text-primary">Personal details</h2>
        {!editing && (
          <button
            type="button"
            onClick={startEdit}
            className="inline-flex items-center gap-1 text-xs text-ga-primary hover:underline"
          >
            <Pencil className="h-3.5 w-3.5" aria-hidden="true" />
            Edit name
          </button>
        )}
      </div>

      <dl className="grid gap-4 sm:grid-cols-2">
        <div>
          <dt className="text-xs font-medium text-ga-text-muted">Display name</dt>
          <dd className="mt-0.5">
            {editing ? (
              <div className="space-y-2">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full rounded-lg border border-ga-border-subtle bg-ga-bg-page px-3 py-2 text-sm text-ga-text-primary focus:outline-none focus:ring-2 focus:ring-ga-primary/30"
                  autoFocus
                />
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={handleSave}
                    disabled={saving}
                    className="inline-flex items-center gap-1 rounded-lg bg-ga-primary px-3 py-1.5 text-xs font-medium text-white hover:bg-ga-primary/90 disabled:opacity-50"
                  >
                    <Check className="h-3.5 w-3.5" aria-hidden="true" />
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={cancelEdit}
                    className="inline-flex items-center gap-1 rounded-lg px-3 py-1.5 text-xs text-ga-text-muted hover:text-ga-text-primary"
                  >
                    <X className="h-3.5 w-3.5" aria-hidden="true" />
                    Cancel
                  </button>
                </div>
                {error && <p className="text-xs text-ga-danger">{error}</p>}
              </div>
            ) : (
              <span className="text-sm text-ga-text-primary">{profile?.name || '—'}</span>
            )}
          </dd>
        </div>
        <ReadOnlyField label="Phone number" value={profile?.phone} />
        <ReadOnlyField label="Role" value={profile?.role_name} />
        <ReadOnlyField label="Facility" value={profile?.facility_name} />
      </dl>
    </section>
  );
}
